// import { scroller } from 'react-scroll';
import _ from 'lodash';
import fillTemplate from 'es6-dynamic-template';

import getProductContent from '../../services/content/get-product-content';

import {
    ADD_ALL_SECTIONS_REQUESTED,
    ADD_ALL_SECTIONS_COMPLETED,
    ADD_ALL_SECTIONS_ERROR,
} from './types';

const addAllSectionsAction = async () => async (dispatch, getState) => {
    dispatch({
        type: ADD_ALL_SECTIONS_REQUESTED,
    });
    const {
        selectproduct,
        content,
    } = getState();

    try {
        const items = [];
        const productCategories = getProductContent(
            selectproduct.get('selectproduct'),
            content.get('content').reasonswhy,
        );

        _.each(productCategories, (category) => {
            _.each(category.items, (item) => {
                items.push({
                    slug: item.slug,
                    content: fillTemplate(item.content),
                });
            });
        });

        return dispatch({
            type: ADD_ALL_SECTIONS_COMPLETED,
            payload: items,
        });
    } catch (err) {
        return dispatch({
            type: ADD_ALL_SECTIONS_ERROR,
            payload: err,
        });
    }
};

export default addAllSectionsAction;
